import React from 'react';
import { palette } from 'src/styles/colors';
import Paragraph from 'src/elements/typography/paragraph';

import { HeroTypeInContainer } from './HeroWordTypeIn.styles';
import WordTypeIn from './WordTypeIn';
import LinkBrandedLarge from 'src/molecules/Standard/Shared/2024_Q3_profit_sales_redesign/LinkBrandedLarge/LinkBrandedLarge';

interface HeroWordTypeInProps {
  heroMainHeadline: string;
  heroSubHeadline?: string;
  heroStaticHighlightedText?: string;
}

const HeroWordTypeIn = ({
  heroMainHeadline,
  heroSubHeadline = null,
  heroStaticHighlightedText,
}: HeroWordTypeInProps): JSX.Element => {
  const heroSubheading =
    heroSubHeadline ||
    'What’s possible when a paid membership, online courses, challenges, or events are powered by AI? Your community essentially runs itself.';

  return (
    <HeroTypeInContainer>
      <WordTypeIn
        heroMainHeadline={heroMainHeadline}
        heroStaticHighlightedText={heroStaticHighlightedText}
      />
      <Paragraph
        text={heroSubheading}
        standardSize='1.5'
        align='center'
        color={palette.white}
        className='hero-paragraph'
      />
      <LinkBrandedLarge
        text='Get Started'
        url='https://cohost.mn.co?plan=free-trial&mode=generator'
      />
    </HeroTypeInContainer>
  );
};

export default HeroWordTypeIn;
